/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../../../config';
import ShopList from '../../../components/ShopList';
import Layout from '../../../layouts/User';
import styles from './AddShop.module.scss';

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'ร้านค้าของฉัน',
  },
];

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const AddShop: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<any>({});
  const [allMyShop, setAllMyShop] = useState<any>([]);
  const [currentPageLocation, setCurrentPageLocation] = useState<any>(
    { lat: 0, long: 0 }
  );
  const [isFetchedData, setIsFetchedData] = useState<boolean>(false);

  const [loading, setLoading] = useState(false);
  const [hasShops, setHasShops] = useState(true);
  const [skip, setSkip] = useState(1);
  const [animationTimeout, setAnimationTimeout] = useState(0);
  const limit = 10;

  const user = useSelector((state: any) => state.user);
  const currentLocationLatLong = useSelector(
    (state: any) => state.currentLocation
  );

  const getMyShop2 = async () => {
    if (loading) return;
    setLoading(true);
    const url = `${BASE_URL}/shop-buyer/shop-buyer2/${currentUser._id}?lat=${currentPageLocation.lat}&long=${currentPageLocation.long}&skip=${skip}&limit=${limit}`;
    const response = await axios.get(url);

    if (response.data.shops.length < limit) {
      setHasShops(false);
    }

    setTimeout(() => {
      setIsFetchedData(true);
      setAnimationTimeout(500);
      setAllMyShop([...allMyShop, ...response.data.shops]);
      setSkip(skip + 1);
      setLoading(false);
    }, animationTimeout);
  };

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  useEffect(() => {
    if (currentLocationLatLong.lat && !isFetchedData) {
      setCurrentPageLocation(currentLocationLatLong);
    }
  }, [currentLocationLatLong]);

  useEffect(() => {
    if (currentUser._id && currentPageLocation.lat) {
      getMyShop2();
    }
  }, [currentUser, currentPageLocation]);

  return (
    <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
      <div className={styles.shopListContainer}>
        {!isFetchedData ? (
          <div style={{ marginTop: '120px', textAlign: 'center' }}>
            <Spin indicator={antIcon} />
            &nbsp;&nbsp;กำลังโหลดรายการร้านค้า
          </div>
        ) : (
          <>
            <div
              className={
                !allMyShop?.length
                  ? styles.container
                  : styles.displayNone
              }
            >
              ท่านยังไม่มีร้านค้าประจำ <br />
              กรุณาเพิ่มร้านค้า
            </div>
            <div
              className={
                !allMyShop?.length
                  ? styles.addshop
                  : styles.addshoplan
              }
            >
              <Link to={'/my-shop/add-my-shop'}>
                <Button type="primary" htmlType="button">
                  เพิ่มร้านค้า
                </Button>
              </Link>
            </div>

            {allMyShop.length > 0 && (
              <InfiniteScroll
                dataLength={allMyShop.length}
                next={getMyShop2}
                hasMore={hasShops}
                loader={
                  <div
                    style={{ marginTop: '20px', textAlign: 'center' }}
                  >
                    <Spin indicator={antIcon} />
                    &nbsp;&nbsp;กำลังโหลดรายการร้านค้า
                  </div>
                }
                style={{ overflow: 'unset' }}
              >
                <ShopList items={allMyShop} from='myShops'/>
              </InfiniteScroll>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};
export default AddShop;
